import mockApi from './mockApi';

// Testnet mode: Using mock API instead of real backend
const api = mockApi;

export default api;
